export interface TenantIdResponse {
  success: boolean;
  tenantId: string;
  name: string;
}
